export const defaultForm = () => ({
	pdf: {
		check: false,
		data: ['application/pdf'],
	},

	word: {
		check: false,
		data: [
			'application/msword',
			'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
			'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
			'application/vnd.ms-word.document.macroenabled.12',
			'application/vnd.ms-word.template.macroenabled.12',
		],
	},

	excel: {
		check: false,
		data: [
			'application/vnd.ms-excel',
			'application/excel',
			'application/x-excel',
			'application/xml',
			'text/xml',
			'application/octet-stream',
			'application/vnd.ms-excel.addin.macroenabled.12',
			'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			'application/vnd.ms-excel.sheet.macroenabled.12',
			'application/vnd.ms-excel.sheet.macroEnabled.12',
			'application/vnd.ms-excel.template.macroenabled.12',
		],
	},

	powerPoint: {
		check: false,
		data: [
			'application/vnd.ms-powerpointtd',
			'application/vnd.ms-powerpoint',
			'application/vnd.openxmlformats-officedocument.presentationml.presentation',
			'application/vnd.openxmlformats-officedocument.presentationml.slide',
			'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
		],
	},

	png: {
		check: false,
		data: ['image/png'],
	},

	jpeg: {
		check: false,
		data: ['image/jpeg'],
	},

	gif: {
		check: false,
		data: ['image/gif'],
	},

	zip: {
		check: false,
		data: [
			'application/x-gzip',
			'application/zip',
			'application/x-compressed-zip',
			'application/x-rar-compressed',
			'application/x-7z-compressed',
			'application/x-compressed'
		],
	},

	video: {
		check: false,
		data: [
			'video/mp4',
			'video/vnd.uvvu.mp4',
			'application/mp4',
			'video/x-msvideo',
			'application/x-msmediaview',
			'application/x-troff-msvideo',
			'video/avi',
			'video/msvideo',
			'video/quicktime',
			'video/3gpp',
			'video/3gpp2',
			'video/x-flv',
			'video/x-f4v',
			'video/h264',
			'video/h263',
			'video/h261',
			'video/mpeg',
			'video/mp4',
		],
	},
	audio: {
		check: false,
		data: ['audio/mpeg', 'audio/x-mpeg', 'audio/mpeg3', 'audio/x-mpeg-3', 'audio/x-ms-wma'],
	},
})
